import React from 'react';

import {Stack} from "@mui/material";
import {sx} from './sx'
import {useLocation} from 'react-router-dom';
import ReportNavigateItemSingleVoyage from "@pages/singleVoyage/reports/allReports/item/ReportNavigateItemSingleVoyage";
import {ALL_REPORTS_NAVIGATE_SINGLE_VOYAGE} from "@pages/singleVoyage/reports/allReports/constants";
import {SxType} from "@baseTypes/sx/sxTypes";

interface IProps {
    sx?: SxType;
}

const AllReportsSingleVoyage = ({sx: sxProps = {}}: IProps) => {

    const location = useLocation();

    const list = ALL_REPORTS_NAVIGATE_SINGLE_VOYAGE.map((item) => {
        const active = location.pathname === item.path;

        return (
            <ReportNavigateItemSingleVoyage
                {...item}
                active={active}
                key={item.path}
            />
        )
    })

    return (
        <Stack
            sx={{
                ...sx.root,
                ...sxProps,
            }}
            gap={1}
        >
            {list}
        </Stack>
    );
};

export default AllReportsSingleVoyage;